import { render, staticRenderFns } from "./ShareSocial.vue?vue&type=template&id=d4bf7c2e"
import script from "./ShareSocial.vue?vue&type=script&lang=js"
export * from "./ShareSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports